/**
 * Created by tking on 08/02/2018.
 */
import {BrokenRule} from './broken-rule';

export class AuditableBaseResult {
  public brokenRules: Array<BrokenRule>;
  public wasSuccessful: boolean;

  constructor(brokenRules: Array<BrokenRule> = null) {
    this.brokenRules = brokenRules;
    this.wasSuccessful = brokenRules == null ? true : brokenRules.length === 0;
  }

  static parseActionResult (json: Object) {
    let success = json['wasSuccessful'];
    let brokenRules: Array<BrokenRule> = null;
    if (!success) {
      brokenRules = json['brokenRules'].map(r => Object.assign(new BrokenRule(), {
        message: r.message
      }));
      return new AuditableBaseResult(brokenRules);
    }
    return new AuditableBaseResult();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-base-result.ts